import { compose } from 'recompose';
import { connect } from 'react-redux';

import Header from 'components/ModalFaqs/Sections/Header/component';

const enhance = compose(connect(() => ({}), {}));

export default enhance(Header);
